(ns practitest.frontend.forms3.link-to-external-modal.main
  (:require
    [practitest.frontend.common.i18n :refer [format-translation
                                             get-translation] :as i18n]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.re-frame :refer [partial-dispatch
                                                 partial-dispatch-sync
                                                 partial-subscribe]]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.forms3.link-to-external-modal.events :as link-to-external-events]
    [practitest.frontend.import-ticket-modal.events :as import-ticket-events]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.forms3.link-to-external-modal.subs :as link-to-external-subs]
    [practitest.frontend.issue.bugtracker :as bugtracker]
    [practitest.frontend.common.bugtrackers :as bugtrackers]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.components2.entity-form.fields :as fields]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.common-entities.metadata :refer [entities-metadata]]
    [clojure.string :as str]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]
))

(defn link-to-external-modal-text-input [{:keys [bugtracker bugtracker-name] :as modal-props}]
  (let [field-id :import-by-key
        text-field-props {:type            "text"
                          :placeholder     (format-translation
                                             (get-translation "entity.form.link_to_bugtracker_modal.placeholder" "Type %{bt} Key")
                                             :bt bugtracker-name)
                          :field-id        field-id
                          :autofocus?      true
                          :get-field-state (partial-subscribe [::forms/field-state field-id])
                          :set-field-state (partial-dispatch-sync [::link-to-external-events/set-field-state])}]
    (fn []
      (let [field-value @(re-frame/subscribe [::link-to-external-subs/get-link-to-external-modal-text-field-value field-id])
            text-field-props (assoc text-field-props :value field-value)]
        [:div.import-modal-text-input
         (when (or (bugtrackers/jira? bugtracker)
                   (bugtrackers/clickup? bugtracker))
           [:span.fs-14 (format-translation
                          (get-translation "entity.form.link_to_bugtracker_modal.text_field_title" "Link by %{bt} Key")
                          :bt bugtracker-name)])
         [fields/text-input text-field-props]]))))

(defn get-bugtracker-params [{:keys [bugtracker entity-type] :as modal-props}]
  (let [id-to-link @(re-frame/subscribe [::link-to-external-subs/get-link-to-external-modal-text-field-value :import-by-key])
        base-params {:entity-type       entity-type
                     :new_link_modal_ui true}]
    (merge base-params
           (cond
             (bugtrackers/jira? bugtracker)
             {:jira_issue_id id-to-link}

             (bugtrackers/clickup? bugtracker)
             {:issue_id id-to-link}))))

(defn get-bugtracker-uri [{:keys [bugtracker entity-type entity-id] :as modal-props}]
  (cond
    (bugtrackers/jira? bugtracker)
    (broutes/get-url (when (= entity-type :requirement)
                       "requirement_integrations#link_to_jira")
                     {:p_id @(re-frame/subscribe [::subs/current-project-id])
                      :id   entity-id})
    (bugtrackers/clickup? bugtracker)
    (broutes/get-url (when (= entity-type :requirement)
                       "requirement_integrations#link_to_clickup")
                     {:p_id @(re-frame/subscribe [::subs/current-project-id])
                      :id   entity-id})))

(defn link-ticket-button [{:keys [entity-type] :as modal-props}]
  (fn [{:keys [on-link]}]
    (let [id-to-link @(re-frame/subscribe [::link-to-external-subs/get-link-to-external-modal-text-field-value :import-by-key])
          params (get-bugtracker-params modal-props)
          uri (get-bugtracker-uri modal-props)
          payload [uri params]
          loading? @(re-frame/subscribe [::subs/progress? ::link-to-external-events/import-tickets])
          disabled (or loading?
                       (str/blank? id-to-link))]
      [buttons/button
       {:disabled? disabled
        :primary?  true
        :toolbar?  true
        :on-click  (fn [_e]
                     (when on-link
                       (mixpanel/track "Link - Link Ticket Modal" {"Entity" entity-type})
                       (on-link payload)))
        :icon      (when loading?
                     [spinners/inline-spinner-border])
        :text      (get-translation "generic.button.link" "Link")
        :size      "large"}])))

(defn cancel-button
  [{:keys [close-dialog entity-type] :as modal-props}]
  [buttons/button
   {:on-click (fn []
                (mixpanel/track "close - Import Ticket Modal" {"Entity" entity-type})
                (re-frame/dispatch [::link-to-external-events/clear-fields])
                (re-frame/dispatch [::link-to-external-events/clear-notifications])
                (close-dialog))
    :toolbar? true
    :text     (get-translation "generic.button.cancel" "Cancel")
    :size     "large"}])

(defn link-to-external-modal-action-buttons
  [modal-props]
  [:div.right-selection.nowrap.add-cancel-component.import-tickets-modal
   [cancel-button modal-props]
   [link-ticket-button modal-props]])

(defn input-section
  [modal-props]
  [link-to-external-modal-text-input modal-props])

(defn link-to-external-modal-body
  [{:keys [bugtracker] :as modal-props}]
  (fn []
    [:div.import-modal-body.mt-3
     [input-section modal-props]
     [link-to-external-modal-action-buttons modal-props]]))

(defn refresh-link []
  [:span {:class    "m-pseudolink"
          :on-click #(re-frame/dispatch [::link-to-external-events/refresh-modal])}
   (get-translation "generic.button.refresh" "Refresh")])

(defn support-link []
  [:a {:href "mailto:support@practitest.com"}
   (get-translation "generic.button.support" "Support")])

(defn notify-ticket-with-link [tickets message type toast-id-suffix class]
  (map (fn [ticket]
         (let [{:keys [requirement issue]} ticket
               entity (cond
                        requirement :requirement
                        issue :issue)
               {:keys [edit]} (get-in entities-metadata [entity :urls])
               entity-data (get ticket entity)
               ticket-id (:display_id entity-data)
               entity-url (broutes/get-url-view edit {:id (get-in ticket [entity :id])})
               id (str toast-id-suffix "-" ticket-id)]
           (notifications/toast-element
             [:div
              [:span.bold
               (format-translation
                 message
                 {:ticket_id ticket-id})]
              " "
              [:a {:href     entity-url
                   :on-click #(do
                                (.preventDefault %)
                                (set! (.-location js/window) entity-url))}
               ticket-id]]
             {:type type :id id :class class})))
       tickets))

(defn notify-errors-with-link [errors type toast-id-suffix class]
  (let [link-failed (get-translation "entity.link_modal.msgs.key.error.link_faild" "Link failed.")
        you-can-click (get-translation "jira.import_modal.msgs.filter.error.you_can_click" "You can click ")
        and-try-again (get-translation "bugtracker.import_modal.msgs.key.error.and_try_again" " and try again or contact ")]
    (map (fn [error-key]
           (let [id (str toast-id-suffix)
                 body [:div
                       [:span.bold error-key " " link-failed]
                       (when (some? (error-key errors))
                         [:<>
                          [:br]
                          [:span {:dangerouslySetInnerHTML {:__html (error-key errors)}}]])
                       [:span you-can-click (refresh-link) and-try-again (support-link)]]]
             (notifications/toast-element body {:type type :id id :class class})))
         (keys errors))))

(defn show-link-to-external-modal []
  (mixpanel/track "Link ticet to Jira modal opened")
  (let [bugtracker (:integrated_bugtracker @(re-frame/subscribe [::subs/current-project]))]
    (if (or (bugtrackers/jira? bugtracker) (bugtrackers/clickup? bugtracker))
      (re-frame/dispatch [::import-ticket-events/check-user-linked nil
                          [::link-to-external-events/toggle-link-to-external-modal]])
      (re-frame/dispatch [::link-to-external-events/toggle-link-to-external-modal]))))

(defn notify-warnings [warnings type toast-id-suffix class]
  (let [grouped (group-by val warnings)]
    (map-indexed (fn [idx [msg entries]]
                   (let [keys-str (str/join ", " (map (comp name key) entries))
                         body [:div
                               [:span.bold keys-str " - " msg]]
                         id (str toast-id-suffix "-" idx)]
                     (notifications/toast-element body {:type type :id id :class class})))
                 grouped)))

(defn display-modal-messages [{:keys [local-state entity-type]} link-results toast-id]
  (let [link-results-map (:link_results link-results)
        {:keys [exist saved not_found not_found_filter linked error warning]} link-results-map
        display-messages? (some not-empty [exist saved not_found not_found_filter linked error warning])

        key-suc-msg (get-translation "entity.link_modal.msgs.key.success" "%{ticket_id} was successfully linked. Go to %{entity_link}")
        key-info-msg (get-translation "entity.link_modal.msgs.key.info" "%{ticket_id} already linked. Go to %{entity_link}")]

    (when display-messages?
      (concat
        (notify-ticket-with-link linked key-suc-msg "success" (str toast-id "-saved") "in-modal-msg-success")
        (notify-ticket-with-link exist key-info-msg "info" (str toast-id "-exist") "in-modal-msg-info")
        (notify-errors-with-link error "error" (str toast-id "-error") "in-modal-msg-error")
        (notify-warnings warning "warning" (str toast-id "-warning") "in-modal-msg-info")))))

(defn link-to-external-modal-footer
  [modal-props]
  (fn []
    (let [link-results @(re-frame/subscribe [::link-to-external-subs/get-link-to-external-modal-notifications])]
      [:div.link-to-external-modal-footer
       [:div.notifications-container
        (display-modal-messages modal-props link-results :toast-id)]])))

(defn link-to-external-modal [container-ref {:keys [title logo show? hide!] :as modal-props}]
  (let [modal-state (reagent/atom {:expanded #{}})]
    (fn [_ modal-props]
      (let [modal-props (merge modal-props
                               {:close-dialog  hide!
                                :local-state   modal-state
                                :container-ref container-ref})]
        [modal/bootstrap-modal
         {:is-open?         @show?
          :on-request-close hide!
          :container-ref    container-ref
          :class            "link-to-external-modal"
          :close-button?    true}

         ;; header
         [:span.import-bugtracker-tickets-modal-header
          [:div.d-flex.gap-12 logo title]]

         ;; body
         [link-to-external-modal-body modal-props]

         ;; footer
         [link-to-external-modal-footer modal-props]]))))

(defn link-to-external-modal-options [{:keys [current-entity form-props]}]
  (let [current-project @(re-frame/subscribe [::subs/current-project])
        bugtracker (:integrated_bugtracker current-project)
        bugtracker-name (bugtrackers/get-label bugtracker)
        title (format-translation
                (get-translation "entity.form.link_to_bugtracker_modal.title" " Link this requirement to a %{bt} Issue ")
                :bt bugtracker-name)]
    {:entity-type     current-entity
     :entity-id       (:entity-id form-props)
     :form-props      form-props
     :show?           (re-frame/subscribe [::link-to-external-subs/show-link-to-external-modal?])
     :hide!           #(re-frame/dispatch [::link-to-external-events/toggle-link-to-external-modal])
     :bugtracker      bugtracker
     :bugtracker-name bugtracker-name
     :logo            [bugtracker/bugtracker-logo]
     :title           title
     :on-link         (partial-dispatch [::link-to-external-events/link-ticket form-props])}))
